<template>
  <section>
    <LoginReset
      :user_id = "user_id"
    />
  </section>
</template>

<script>
import LoginReset from '@/views/Login/LoginReset'
export default {
  name: 'LoginResetRequest',
  components: {
    LoginReset
  },
  props: {
    user_id: {
      type: String,
      default: '',
      required: true
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/LoginResetRequest.vue